import React from "react";
import {
  Routes,
  BrowserRouter as Router,
  Route,
  Navigate,
} from "react-router-dom";
import ReactGA from "react-ga4";

// Views
import Header from "./components/layout/Header";
import Footer from "./components/layout/Footer";

// Home
import Home from "./views/home/Home";

// OurStory
import OurStory from "./views/our-story/OurStory";

// OurWork
import OurWork from "./views/our-works/OurWork";
import ProjectPage from "./views/our-works/ProjectPage";

// Careers
import Careers from "./views/careers/Careers";
import PositionPage from "./views/careers/Position/PositionPage";

// Contact
import Contact from "./views/contact-us/ContactUs";
import PageNotFound from "./views/page-not-found/PageNotFound";

// Initialize Google Analytics
if (process.env.REACT_APP_GA_MEASUREMENT_ID) {
  ReactGA.initialize(process.env.REACT_APP_GA_MEASUREMENT_ID);
}

const App = () => {
  return (
    <Router>
      <Header />
      <main className="site-content">
        <Routes>
          {/* Home */}
          <Route path="/" element={<Home />} />
          <Route path="/home" element={<Navigate to="/" replace />} />

          {/* OurStory */}
          <Route path="/our-story" element={<OurStory />} />
          <Route path="/our-story/*" element={<Navigate to="/our-story" replace />} />

          {/* OurWork */}
          <Route path="/our-works" element={<OurWork />} />
          <Route path="/our-works/:slug" element={<ProjectPage />} />
          <Route path="/our-works/*" element={<Navigate to="/our-works" replace />} />

          {/* Careers */}
          <Route path="/careers" element={<Careers />} />
          <Route path="/careers/:slug" element={<PositionPage />} />
          <Route path="/careers/*" element={<Navigate to="/careers" replace />} />

          {/* Contact */}
          <Route path="/contact-us" element={<Contact />} />
          <Route path="/contact-us/*" element={<Navigate to="/contact-us" replace />} />

          {/* PageNotFound */}
          <Route path="*" element={<PageNotFound />} />
        </Routes>
      </main>
      <Footer />
    </Router>
  );
};

export default App;
